import { selectCheckoutCurrentStep, selectCheckoutSteps } from 'checkout/selectors/checkoutStepsSelectors'
import StepperProgressStep from 'components/Luxkit/Steppers/StepperProgressStep'
import StepperProgressSteps from 'components/Luxkit/Steppers/StepperProgressSteps'
import StepperProgressText from 'components/Luxkit/Steppers/StepperProgressText'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import React, { useMemo } from 'react'
import { connect } from 'react-redux'

interface MappedStateProps {
  steps: Array<App.Checkout.CheckoutStep>
  currentStep: App.Checkout.CheckoutStep | undefined
}

function CheckoutStepperProgress(props: MappedStateProps) {
  const {
    steps,
    currentStep,
  } = props

  const currentStepIndex = useMemo<number | undefined>(() => {
    if (!currentStep) return
    return steps.findIndex(step => step.key === currentStep.key)
  }, [currentStep, steps])

  if (!steps.length || currentStepIndex === undefined) return null

  return <>
    <CSSBreakpoint max="tablet">
      <StepperProgressText
        stepLabel={currentStep!.label}
        currentStepNumber={currentStepIndex + 1}
        totalSteps={steps.length}
      />
    </CSSBreakpoint>
    <CSSBreakpoint min="desktop">
      <StepperProgressSteps activeStepIndex={currentStepIndex}>
        {steps.map((step, stepIndex) => <StepperProgressStep
          key={step.key}
          stepIndex={stepIndex}
          label={step.label}
        />)}
      </StepperProgressSteps>
    </CSSBreakpoint>
  </>
}

export default connect<MappedStateProps, {}, {}, App.State>((state) => {
  return {
    steps: selectCheckoutSteps(state),
    currentStep: selectCheckoutCurrentStep(state),
  }
})(CheckoutStepperProgress)
